"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// import { FILE } from '../constants/action_type';

const initialState = {};
const formReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    // case FILE.ADD_INIT:
    // case FILE.ADD_FAIL:
    // case FILE.ADD_DONE:
    // case FILE.CONVERT_DONE:
    // case FILE.CONVERT_FAIL:
    //   return Object.assign({}, state, initialState);
    default:
      return state;
  }
};
var _default = exports.default = formReducer;